import {useRef} from "react"

import styles from "./BeautifulScreenshot.module.css"

import { usePalette } from 'color-thief-react'

import * as htmlToImage from 'html-to-image';

import { db } from '../../../firebase';
import { doc, updateDoc, collection, query, where, getDocs, getDoc, setDoc } from "firebase/firestore";

import { getDownloadURL, getStorage, ref, uploadString } from "firebase/storage";

import { useAuth } from '../../../contexts/authContext';

export default function BeautifulScreenshot(props) {
  const { data, loading, error } = usePalette(props.userImage, 2, "hex", {crossOrigin: "http://localhost:3000"})

  const {currentUser} = useAuth()

  async function handleImageLoad() {
    const searchParams = new URLSearchParams(window.location.href)

    const querySnapshot = await getDocs(collection(db, "users"));
    // const querySnapshot = await getDocs(collection(db, "users"));

    const designs = [];
    
    querySnapshot.forEach(async (document) => {
      if (document.id === currentUser.uid) {
        const data = document.data().allDesigns[searchParams.get("designId")].neverLoaded;

        if (data) {
          const storage = getStorage();
          const storageRef = ref(storage, `${currentUser.uid} ${searchParams.get("designId")}'s thumbnail`);
        
          console.log("Image loaded")
        
          const docRef = doc(db, "users", currentUser.uid);
        
          htmlToImage.toPng(props.testRef.current)
            .then(async function (dataUrl) {
              // thumbnailURL = dataUrl;
        
              // console.log(thumbnailURL)
        
              const message4 = dataUrl;
              
              await uploadString(storageRef, message4, 'data_url').then(async (snapshot) => {
                const thumbnailURL = await getDownloadURL(storageRef)
        
                const obj = {};
        
                obj.allDesigns = {}
        
                obj.allDesigns[searchParams.get("designId")] = {
                  thumbnailUrl: thumbnailURL,
                  neverLoaded: false,
                }
            
                await setDoc(docRef, obj, {merge:true});
              });
        
              console.log("THUMBNAIL SAVED")
            });
        }
  
      }
    })
  
  }

  const gradientBgValue = `linear-gradient(${props.bgGradientRotation}deg, ${(props.bgValueGradient && props.bgValueGradient[0]) || (data && data[0])} 0%, ${(props.bgValueGradient && props.bgValueGradient[1]) || (data && data[1])} 100%)`;
  const solidBgValue = props.bgValueSolid || (data && data[0]);

  if (!props.bgValueSolid) {
    props.setBgValueSolid((data && data[0]))
  }

  if (!props.bgValueGradient) {
    props.setBgValueGradient((data && [data[0], data[1]]))
  }

  const shadow = `drop-shadow(${props.xOffset}px ${props.yOffset}px ${props.blurRadius}px ${props.shadowColor}${props.shadowOpacity == 100 ? "FF" : props.shadowOpacity}`;
  const customPadding = `${props.topPadding}px ${props.leftPadding}px ${props.bottomPadding}px ${props.rightPadding}px`

  return (
    <div className={styles.screenshotContainer} style={{display: `${!props.userImage ? "none" : "flex"}`}}>
      {!loading &&
        <div ref={props.testRef} id="my-node" className={styles.gradient} style={{transform: `scale(${props.zoom})`, borderRadius: `${props.bgBorderRadius}px`, padding: `${props.linkedPadding ? props.padding+"px" : customPadding}`, background: props.bgType === "gradient" ? gradientBgValue : solidBgValue}}>
          <img onLoad={handleImageLoad} src={props.userImage} className={styles.screenshot} style={{filter: `${props.shadowEnabled === "on" ?  shadow: ""}`, borderRadius: `${props.imgBorderRadius}px`}} draggable={false}  />

          {/* <p className={styles.waterMark}>WideSketch</p> */}
        </div>
      }
    </div>
  )
}
